export const state = () => ({
  menu: [],
  links: [],
  siteInfo: {},
  updated: {
    menu: '',
    links: '',
    siteInfo: '',
  },

  keyword: '',

  // 默认csr渲染模式
  renderData: {
    mode: 'csr',
    loading: false,
  },
});

export const mutations = {
  setMenu(state, data) {
    state.menu = data;
  },

  setLinks(state, data) {
    state.links = data;
  },

  setSiteInfo(state, data) {
    state.siteInfo = data;
  },

  setUpdated(state, data) {
    state.updated = data;
  },

  setKeyword(state, data) {
    state.keyword = data;
  },

  setRenderData(state, data) {
    state.renderData = {
      ...state.renderData,
      ...data,
    };
  },
};

export const actions = {
  async getCommonData({ commit }, { app }) {
    const [menu, links, siteInfo] = await Promise.all([
      app.$service.learning.getMenu(),
      app.$service.learning.getFooterLinks(),
      app.$service.learning.getSiteInfo(),
    ]);

    commit('setMenu', menu.data || app?.$cache?.CACHE_MENU || []);
    commit('setLinks', links.data || app?.$cache?.CACHE_FOOTER || []);
    commit('setSiteInfo', siteInfo.data || app?.$cache?.CACHE_SITEINFO || {});
    commit('setUpdated', {
      menu: menu._updated,
      links: links._updated,
      siteInfo: siteInfo._updated,
    });
  },
};
